var React = require('react');
var ReactNative = require('react-native');

var ModelConstants = require('./constants/ModelConstants.js');
var CryptoJS = require('crypto-js');
var Buffer = require('buffer').Buffer;
var AnalyticsManager = require('./AnalyticsManager');

// var $ = require('@rtorr/ajax-only');
// var Feed = require('./reup-components/Feed');

var shouldRecordHistory = false;
var shouldUseHistory = false;

var ENABLE_LOGGING = false;
 //ENABLE_LOGGING = true;

global.btoa = function (str) {return new Buffer(str).toString('base64');};
global.atob = function (str) {return new Buffer(str, 'base64').toString('ascii')}

var AVAILABLE_CHARS_FOR_RANDOM_STRING = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function randomString(length) {
    var result = '';
    for (var i = length; i > 0; --i) result += AVAILABLE_CHARS_FOR_RANDOM_STRING[Math.floor(Math.random() * AVAILABLE_CHARS_FOR_RANDOM_STRING.length)];
    return result;
}

var NetworkManager =
{
	_getAllPreviouslyUpdate: {},
	updateFeature: function( appManager, featureName, success, failure )
	{
		var methodName = featureName == "Users" ? "GetUser" : "Get" + featureName;
		var thisThing = this;
    appManager.getCurrentUser(function(user)
    {
      var parameters = user != null ? [user[ModelConstants.UserName]] : [];
  		thisThing.rpcCall(appManager, methodName, parameters, function(data)
  		{
  			var featureDatas = {};
  			if( featureName == "Users" )
  			{
  				featureDatas[featureName] = [data];
  			}
  			else
  			{
  				featureDatas[featureName] = data;
  			}
  			// NetworkActions.featureUpdated(featureDatas);
  			success(data)
  		}, function(data)
  		{
  			if( typeof failure !== 'undefined' ) failure(data);
  		}, function(data)
  		{
  			if( typeof failure !== 'undefined' ) failure(data);
  		});
    })
	},

	hasUpdated: function(featureNames)
	{
		for( var i = 0; i < featureNames.length; i++ )
		{
			var featureName = featureNames[i];
			if( typeof this._getAllPreviouslyUpdate[featureName] === 'undefined' || !this._getAllPreviouslyUpdate[featureName] )
			{
				return false;
			}
		}

		return true;
	},

	update: function( appManager, featureNames, success, failure )
	{
		if( typeof featureNames === 'undefined' || featureNames == null || featureNames.length <= 0 )
		{
			success({});
			return;
		}

		for( var i = 0; i < featureNames.length; i++ )
		{
			var featureName = featureNames[i];
			this._getAllPreviouslyUpdate[featureName] = true;
		}

		var methodName = "GetAll";
		var featureNamesRefined = [];
		for( var i = 0; i < featureNames.length; i++ )
		{
			var featureName = featureNames[i];
			if( featureName == "Users" || featureName == "User" )
			{
				if( appManager.isLoggedIn() ) featureNamesRefined.push("User")
			}
			else
			{
				featureNamesRefined.push(featureName);
			}
		}
		this.rpcCall(appManager, methodName, [featureNamesRefined], function(data, error)
		{
			for( var key in data )
			{
				if( (key == "Users" || key == "User") && typeof data[key].UserID !== 'undefined' )
				{
					data["Users"] = [data[key]];
				}
			}
			//console.log("Getall: " + JSON.stringify(data))
			success(data, error)
		}, function(data)
		{
			// alert(JSON.stringify(data))
			failure(data);
		}, function(data)
		{
			// alert(JSON.stringify(data))
			failure(data);
		});
	},

	updateUser: function( appManager, userObject, success, failure, networkFailure )
	{
		var methodName = "UpdateUser";
		var parameters = [userObject];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	login: function( appManager, username, password, success, fail, networkFailure )
	{
		var methodName = "GetUser";
		var networkManager = this;
    appManager.getCurrentUser(function(user)
    {
      var parameters = user != null ? [user[ModelConstants.UserName]] : [];
  		networkManager.rpcCallUserPass( appManager, username, password, methodName, parameters, function(data)
  		{
  			var featureDatas = {};
  			data[ModelConstants.Password] = password;
  			featureDatas["Users"] = [data];
				//console.log(JSON.stringify(data))
  			// NetworkActions.featureUpdated(featureDatas)
  			if( data[ModelConstants.UserName].length > 0 )
  			{
  				// NetworkActions.userLoggedIn(data)
  			}
  			success(data);
  		}, function(data)
  		{
  			fail(data);
  		}, function(data)
  		{
  			if( typeof networkFailure !== 'undefined' ) networkFailure(data);
  		});
    })
	},

	_domain: "",
	domainLogin: function( appManager, domain, username, password, success, failure )
	{
		var methodName = "GetUser";
		appManager._domain = domain;
		var parameters = [username, password];
		this.rpcCallUserPass( appManager, username, password, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	createUser: function( appManager, username, password, firstName, lastName, birthday, refCode, optIn, success, failure )
	{
		var methodName = "CreateAccount";
		var parameters = [username, password, firstName, lastName, birthday, refCode, optIn];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data["UserName"]);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	createUserVerified: function( appManager, username, password, firstName, lastName, birthday, refCode, optIn, success, failure )
	{
		var methodName = "CreateAccountVerified";
		var parameters = [username, password, firstName, lastName, birthday, refCode, optIn];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data["UserName"]);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	createUserEmail: function( appManager, username, firstName, lastName, birthday, refCode, optIn, linkUserID, linkUserHash, success, failure )
	{
		var methodName = "CreateAccountWithEmail";
		var parameters = [username, firstName, lastName, birthday, refCode, optIn, linkUserID, linkUserHash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	createUserFacebook: function( appManager, facebookID, refCode, optIn, success, failure )
	{
		var methodName = "CreateAccountFacebook";
		var parameters = [facebookID, refCode, optIn];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data["UserName"]);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	getUser: function( appManager, userID, hash, success, failure )
	{
		var methodName = "GetUser";
		var parameters = [userID, hash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	optOutPhone: function( appManager, userID, hash, success, failure )
	{
		var methodName = "OptOutPhone";
		var parameters = [userID, hash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	optInPhone: function( appManager, userID, hash, success, failure )
	{
		var methodName = "OptInPhone";
		var parameters = [userID, hash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	optOutEmail: function( appManager, userID, hash, success, failure )
	{
		var methodName = "OptOutEmail";
		var parameters = [userID, hash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	optInEmail: function( appManager, userID, hash, success, failure )
	{
		var methodName = "OptInEmail";
		var parameters = [userID, hash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	linkUsers: function( appManager, userID, hash, success, failure )
	{
		var methodName = "LinkUsers";
		var parameters = [userID, hash];
		this.rpcCall( appManager, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	getLinkedUsers: function( appManager, userID, hash, success, failure )
	{
		var methodName = "GetLinkedUsers";
		var parameters = [userID, hash];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			failure(data);
		});
	},

	refund: function( appManager, transactionID, success, failure )
	{
		var thisThing = this;
		var methodName = "RefundTransaction";
		var parameters = [transactionID];
		var thisThing = this;
		appManager.getCurrentUser(function(user)
    {
  		thisThing.rpcCall(appManager, methodName, parameters, function(data)
  		{
  			success(data)
  		}, function(data)
  		{
  			if( typeof failure !== 'undefined' ) failure(data);
  		}, function(data)
  		{
  			if( typeof failure !== 'undefined' ) failure(data);
  		});
    })
	},

	sendPhoneNumberCode: function( appManager, phoneNumber, success, failure, networkFailure )
	{
		var methodName = "SendPhoneNumberCode";
		var parameters = [phoneNumber];
		this.rpcCall( appManager, methodName, parameters, function(data)
		{
			success();
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			if( typeof networkFailure !== 'undefined' ) networkFailure();
		});
	},

	verifyAndSetPhoneNumber: function( appManager, phoneNumber, code, success, failure, networkFailure )
	{
		var methodName = "VerifyAndSetPhoneNumber";
		var parameters = [phoneNumber, code];
		this.rpcCall( appManager, methodName, parameters, function(data)
		{
			success(data);
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			if( typeof networkFailure !== 'undefined' ) networkFailure();
		});
	},

	forgotPassword: function( appManager, username, success, failure, networkFailure )
	{
		var methodName = "ForgotPassword";
		var parameters = [username];
		this.rpcCallUserPass( appManager, null, null, methodName, parameters, function(data)
		{
			success();
		},
		function(data)
		{
			failure(data);
		},
		function(data)
		{
			if( typeof networkFailure !== 'undefined' ) networkFailure();
		});
	},

	getOneTimeRewards: function( appManager, userID, hash, success, failure, networkFailure )
	{
		var methodName = "GetOneTimeRewards";
		var parameters = [];
		if( userID != null && hash != null ) parameters = [userID, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, function(data)
		{
			if( typeof networkFailure !== 'undefined' ) networkFailure();
		});
	},

	unverifyAccount: function( appManager, userID, hash, success, failure, networkFailure )
	{
		var methodName = "UnverifyAccount";
		var parameters = [userID, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	resendVerification: function( appManager, userID, hash, success, failure, networkFailure )
	{
		var methodName = "ResendVerification";
		var parameters = [userID, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	stripeFetchToken : function(stripePublicKey, cardNumber, expMonth, expYear, cvc, postalZip, success, networkFailure)
	{
	  var cardDetails = {
	    "card[number]": cardNumber,
	    "card[exp_month]": expMonth,
	    "card[exp_year]": expYear,
	    "card[cvc]": cvc
	  };

		if( postalZip != null )
		{
			cardDetails["card[address_zip]"] = postalZip;
			// cardDetails["card[address_zip_check]"] = "fail";
		}

	  var formBody = [];
	  for (var property in cardDetails)
		{
	    var encodedKey = encodeURIComponent(property);
	    var encodedValue = encodeURIComponent(cardDetails[property]);
	    formBody.push(encodedKey + "=" + encodedValue);
	  }
	  formBody = formBody.join("&");

		if( ENABLE_LOGGING )
		{
			console.log('https://api.stripe.com/v1/tokens', formBody)
		}

		var responseTextCached = "";
	  return fetch('https://api.stripe.com/v1/tokens',
		{
	    method: 'post',
	    headers:
			{
	      'Accept': 'application/json',
	      'Content-Type': 'application/x-www-form-urlencoded',
	      'Authorization': 'Bearer ' + stripePublicKey
	    },
	    body: formBody
		}).then((response) => response.text())
    .then((responseText) =>
    {
			responseTextCached = responseText;
			if( ENABLE_LOGGING ) console.log(responseText);
      var data = JSON.parse(responseText);
				//console.log("not err?: " + JSON.stringify(responseText))
			success(data);
    })
    .catch((err) => {
			AnalyticsManager.logException("stripeFetchToken error :: " + JSON.stringify(err))
			if( ENABLE_LOGGING ) console.log("dataerr: " + JSON.stringify(err))
      if( networkFailure ) networkFailure(err);
    });
	},

	beanStreamFetchToken: function(cardNumber, expMonth, expYear, cvc, success, networkFailure)
	{
		var url = "https://www.beanstream.com/scripts/tokenization/tokens";
	  var cardDetails = {
	    "number": cardNumber,
	    "expiry_month": expMonth,
	    "expiry_year": expYear,
	    "cvd": cvc
	  };

	  var formBody = [];
	  for (var property in cardDetails)
		{
	    var encodedKey = encodeURIComponent(property);
	    var encodedValue = encodeURIComponent(cardDetails[property]);
	    formBody.push(encodedKey + "=" + encodedValue);
	  }
	  formBody = formBody.join("&");

		formBody = JSON.stringify(cardDetails);
		var responseTextCached = "";
	  return fetch(url,
		{
	    method: 'post',
	    headers:
			{
	      'Accept': 'application/json',
	      'Content-Type': 'application/x-www-form-urlencoded'
	    },
	    body: formBody
		}).then((response) => response.text())
    .then((responseText) =>
    {
			responseTextCached = responseText;
      var data = JSON.parse(responseText);
				//console.log("beanstream: " + JSON.stringify(responseText))
			success(data);
    })
    .catch((err) => {
			//console.log("dataerr: " + JSON.stringify(err))
			AnalyticsManager.logException("beanStreamFetchToken error :: " + responseTextCached + " :: " + JSON.stringify(err))
      if( networkFailure ) networkFailure(err);
    });
	},

	setPayPal : function( appManager, authorizationToken, username, success, failure, networkFailure )
	{
		var methodName = "SetPP";
		var parameters = [authorizationToken, username];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	setCreditCard: function( appManager, token, lastFour, expMonth, expYear, cardType, success, failure, networkFailure )
	{
		var methodName = "SetCC";
		var parameters = [token, lastFour, expMonth, expYear, cardType];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	submitPPPayment: function( appManager, amount, clientMetadataID, refreshToken, success, failure, networkFailure )
	{
		var methodName = "ChargePP";
		var parameters = [amount, clientMetadataID, refreshToken];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	submitCCPayment: function( appManager, amount, cardID, success, failure, networkFailure )
	{
		var methodName = "ChargeCC";
		var parameters = [amount, cardID];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	submitPayment: function( appManager, amount, paymentObj, success, failure, networkFailure )
	{
		var methodName = "ChargeAndAddCredit";
		var parameters = [amount, paymentObj];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	submitPassPayment: function( appManager, passID, paymentObj, success, failure, networkFailure )
	{
		var methodName = "ChargeAndAddPass";
		var parameters = [passID, paymentObj];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	vendorRedeemPass: function( appManager, userID, passID, hash, success, failure, networkFailure )
	{
		var methodName = "VendorRedeemPass";
		var parameters = [userID, passID, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	sendCredit: function( appManager, amount, email, message, firstName, lastName, success, failure, networkFailure )
	{
		var methodName = "SendCredit";
		var parameters = [amount, email, message, firstName, lastName];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	sendGiftCard: function( appManager, amount, email, message, firstName, lastName, paymentObj, success, failure, networkFailure )
	{
		var methodName = "SendGC";
		var parameters = [amount, email, message, firstName, lastName, paymentObj];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	absorbGiftCardByUserID: function( appManager, giftCardUserID, pin, success, failure, networkFailure )
	{
		var methodName = "AbsorbGCByUserID";
		var parameters = [giftCardUserID, pin];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	absorbGiftCardByNumber: function( appManager, giftCardNumber, pin, success, failure, networkFailure )
	{
		var methodName = "AbsorbGCByGCNum";
		var parameters = [giftCardNumber, pin];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	vendorUseCredit: function( appManager, userID, amount, userType, hash, tipType, tipAmount, success, failure, networkFailure)
	{
		var methodName = "VendorUseCredit";
		var parameters = [userID, amount, userType, hash, tipType, tipAmount];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	vendorAddCreditGC: function( appManager, userID, amount, userType, hash, success, failure, networkFailure)
	{
		var methodName = "VendorAddCreditGiftCard";
		var parameters = [userID, amount, userType, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	vendorRedeemReward: function( appManager, userID, rewardID, userType, hash, success, failure, networkFailure )
	{
		var methodName = "VendorRedeemReward";
		var parameters = [userID, rewardID, userType, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	clientRedeemReward: function( appManager, rewardID, success, failure, networkFailure )
	{
		var methodName = "RedeemReward";
		var parameters = [rewardID];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	vendorCheckIn: function( appManager, userID, dollarAmount, userType, hash, success, failure, networkFailure )
	{
		var methodName = "CheckIn";
		var parameters = [userID, hash, dollarAmount];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	vendorTransferLoyaltyCampaign: function( appManager, userID, email, phone, externalID, hash, success, failure, networkFailure )
	{
		var methodName = "TransferLoyaltyToGiftCard";
		var parameters = [userID, hash, email, phone, externalID];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	referEmail: function( appManager, email, firstName, lastName, success, failure, networkFailure )
	{
		var methodName = "SendReferralEmail";
		var parameters = [email, firstName, lastName];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	transferLoyaltyCampaign: function( appManager, email, phone, cardID, success, failure, networkFailure )
	{
		var methodName = "TransferLoyalty";
		var parameters = [email,phone, cardID];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getGCInfoByUserID: function( appManager, giftCardUserID, pin, success, failure, networkFailure )
	{
		var methodName = "GetGCInfoByUserID";
		var parameters = [giftCardUserID, pin];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getGCInfoByGCNum: function( appManager, giftCardNumber, pin, success, failure, networkFailure )
	{
		var methodName = "GetGCInfoByGCNum";
		var parameters = [giftCardNumber, pin];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getGCInfoByUserIDVendor: function( appManager, userID, hash, success, failure, networkFailure )
	{
		var methodName = "VendorGetGCUser";
		var parameters = [userID, hash];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
		// this.rpcCall( appManager, methodName, parameters, success, function(data){success({UserID:123,Credit:23.4,Points:167})}, networkFailure);
	},

	setPrimaryPaymentMethod: function( appManager, refreshOrCardID, success, failure, networkFailure )
	{
		var methodName = "SetPrimaryPaymentMethod";
		var parameters = [refreshOrCardID];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	removePaymentMethod: function( appManager, refreshOrCardID, success, failure, networkFailure )
	{
		var methodName = "RemovePaymentMethod";
		var parameters = [refreshOrCardID];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	changePassword: function(appManager, newPassword, success, failure, networkFailure )
	{
		var methodName = "ChangePassword";
		var parameters = [newPassword];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	resendVerifyEmail: function(appManager, email, success, failure, networkFailure)
	{
		var methodName = "SendVerifyEmail";
		var parameters = [email];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	joinGroup: function(appManager, groupCode, success, failure, networkFailure)
	{
		var methodName = "JoinGroup";
		var parameters = [groupCode];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getGrabbInfo: function(appManager, merchantID, currentDateTime, success, failure, networkFailure)
	{
		var methodName = "GetGrabbLocations";
		var parameters = [merchantID, currentDateTime];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getAuphanInfo: function(appManager, orderingType, merchantID, currentDateTime, lat, lng, success, failure, networkFailure)
	{
		var methodName = "GetOrderingLocations";
		var parameters = [merchantID, currentDateTime, lat, lng, orderingType];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getActiveOrders: function(appManager, orderingType, merchantID, locationID, token, currentDateTime, lat, lng, success, failure, networkFailure)
	{
		var methodName = "GetOrderingActiveOrders";
		var parameters = [merchantID, currentDateTime, lat, lng, locationID, token, orderingType];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	uploadSelfie: function(appManager, selfieURL, success, failure, networkFailure)
	{
		var methodName = "UploadSelfieToAmazon";
		var parameters = [selfieURL];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	lookUpUserByPhone: function(appManager, phoneNumber, success, failure, networkFailure)
	{
		var methodName = "LookUpUserByPhone";
		var parameters = [phoneNumber];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	createUserByPhone: function(appManager, phone,countryCode, recaptcha, success, failure, networkFailure)
	{
		var methodName = "CreateAccountWithPhone";
		var parameters = [phone,null,null,null,null,null,countryCode, recaptcha];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	_companyLogin : "reupdemo4",
	_apiKey : "4ac8f50ea5f13f8c5e0a2f6175a763c3213c2e50b66882bbb93611f94620b77f",
	getSimplyBookToken: function(appManager, success, failure, networkFailure)
	{
		var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
		var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
		if( appManager.SIMPLY_BOOK_TOKEN != null && typeof appManager.SIMPLY_BOOK_TOKEN !== 'undefined' )
		{
			success(appManager.SIMPLY_BOOK_TOKEN)
		}
		else
		{
			this.callURL("https://user-api.simplybook.me/login", null, null, {"jsonrpc":"2.0","method":"getToken","params":[companyLogin,apiKey],"id":randomString(8)},
			function(data)
			{
				appManager.SIMPLY_BOOK_TOKEN = JSON.parse(data).result;
				success(appManager.SIMPLY_BOOK_TOKEN);
			}, failure, networkFailure)
		}
	},

	getSimplyBookEvents: function(appManager, success, failure, networkFailure)
	{
		var thisThing = this;
		var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
		var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
		if( appManager.SIMPLY_BOOK_EVENTS != null && typeof appManager.SIMPLY_BOOK_EVENTS !== 'undefined' )
		{
			success(appManager.SIMPLY_BOOK_EVENTS)
		}
		else
		{
			this.getSimplyBookToken(appManager, function(token)
			{
				thisThing.callURL("https://user-api.simplybook.me/", null, {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"getEventList","params":[],"id":randomString(8)},
				function(dataString)
				{
					var events = [];
					var data = JSON.parse(dataString);
					for( var key in data.result )
					{
						events.push(data.result[key])
					}
					appManager.SIMPLY_BOOK_EVENTS = events;
					success(appManager.SIMPLY_BOOK_EVENTS);
				}, failure, networkFailure)
			}, failure, networkFailure);
		}
	},

	getSimplyBookPerformers: function(appManager, success, failure, networkFailure)
	{
		var thisThing = this;
		var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
		var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
		if( appManager.SIMPLY_BOOK_PERFORMERS != null && typeof appManager.SIMPLY_BOOK_PERFORMERS !== 'undefined' )
		{
			success(appManager.SIMPLY_BOOK_PERFORMERS)
		}
		else
		{
			this.getSimplyBookToken(appManager, function(token)
			{
				thisThing.callURL("https://user-api.simplybook.me/", null, {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"getUnitList","params":[],"id":randomString(8)},
				function(dataString)
				{
					var performers = [];
					var data = JSON.parse(dataString);
					for( var key in data.result )
					{
						performers.push(data.result[key])
					}
					appManager.SIMPLY_BOOK_PERFORMERS = performers;
					success(appManager.SIMPLY_BOOK_PERFORMERS);
				}, failure, networkFailure)
			}, failure, networkFailure);
		}
	},

	getSimplyBookTimeIntervals: function( appManager, dateFrom, dateTo, eventID, unitID, success, failure, networkFailure )
	{
		var thisThing = this;
		var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
		var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
		this.getSimplyBookToken(appManager, function(token)
		{
			var mm = dateFrom.getMonth() + 1; // getMonth() is zero-based
		  var dd = dateFrom.getDate();
			var dateStringFrom = [dateFrom.getFullYear(), mm <= 9 ? '0' : "", mm, dd <= 9 ? '0' : "", dd].join('');

			var mm = dateTo.getMonth() + 1; // getMonth() is zero-based
		  var dd = dateTo.getDate();
			var dateStringTo = [dateTo.getFullYear(), mm <= 9 ? '0' : "", mm, dd <= 9 ? '0' : "", dd].join('');

			// console.log("https://user-api.simplybook.me/", {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"getAvailableTimeIntervals","params":[dateStringFrom, dateStringTo, eventID, unitID, "1"],"id":1})
			thisThing.callURL("https://user-api.simplybook.me/", null, {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"getAvailableTimeIntervals","params":[dateStringFrom, dateStringTo, eventID, unitID, "1"],"id":randomString(8)},
			function(dataString)
			{
	      // console.log("getSimplyBookTimeIntervals",dataString)
				var data = JSON.parse(dataString);
				success(data.result);
			}, failure, networkFailure)
		}, failure, networkFailure);
	},

	getSimplyBookTimeframe: function( appManager, success, failure, networkFailure )
	{
		if( appManager.SIMPLY_BOOK_TIMEFRAME != null && typeof appManager.SIMPLY_BOOK_TIMEFRAME !== 'undefined' )
		{
			success(appManager.SIMPLY_BOOK_TIMEFRAME)
		}
		else
		{
			var thisThing = this;
			var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
			var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
			this.getSimplyBookToken(appManager, function(token)
			{
				thisThing.callURL("https://user-api.simplybook.me/", null, {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"getTimeframe","params":[],"id":randomString(8)},
				function(dataString)
				{
					var data = JSON.parse(dataString);
					success(data.result);
				}, failure, networkFailure)
			}, failure, networkFailure);
		}
	},

	bookSimplyBook: function( appManager, eventID, unitID, date, startTimeMinutes, clientData, success, failure, networkFailure )
	{
		var thisThing = this;
		var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
		var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
		this.getSimplyBookToken(appManager, function(token)
		{
			var mm = date.getMonth() + 1; // getMonth() is zero-based
		  var dd = date.getDate();
			var dateString = [date.getFullYear(), "-", mm <= 9 ? '0' : '', mm, "-", dd <= 9 ? '0' : '', dd].join('');

			var hours = Math.floor(startTimeMinutes / 60);
			var minutes = startTimeMinutes % 60;
			var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes + ":00";

			thisThing.callURL("https://user-api.simplybook.me/", null, {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"book","params":[eventID, unitID, dateString, timeString, clientData],"id":randomString(8)},
			function(dataString)
			{
				var data = JSON.parse(dataString);
				success(data.result);
			}, failure, networkFailure)
		}, failure, networkFailure);
	},

	callURL: function(url, auth, addedHeaders, body, success, failure, networkFailure)
	{
		var params = {method: 'get'};
		var postfix = "";

		params.headers = {"Content-Type":'application/json; charset=UTF-8'};
		if( typeof auth !== 'undefined' && auth != null )
		{
			params.headers.Authorization = auth;
		}

		if( addedHeaders != null && typeof addedHeaders !== 'undefined' )
		{
			for( var key in addedHeaders )
			{
				params.headers[key] = addedHeaders[key];
			}
		}

		if( typeof body !== 'undefined' && body != null )
		{
			params.body = JSON.stringify(body);
			params.headers["Content-Length"] = params.body.length;
			params.headers.Accept = "application/json";
			params.method = "POST"
			// postfix = "?"
			// for( var key in body )
			// {
			// 	if( postfix.length > 1 ) postfix += "&"
			// 	postfix += key + "=" + encodeURIComponent(body[key])
			// }
		}

		var responseTextCached = "";
		fetch(url + postfix, params)
    .then((response) => response.text())
    .then((responseText) =>
    {
			responseTextCached = responseText;
			success(responseText);
    })
    .catch((err) =>
		{
			//console.log("ERR: " + err)
			AnalyticsManager.logException("callURL error :: " + url + " :: " + responseTextCached + " :: " + err)
      networkFailure(err);
    });
	},

	retrieveCustomDataDependencies: function(appManager, customDataDependencies, data, completion, index)
	{
		if( typeof index === 'undefined' ) index = 0;

		if( index >= customDataDependencies.length || typeof customDataDependencies[index] === 'undefined' )
		{
			completion(data);
			return;
		}
		customDataDependencies[index](appManager, function(newData)
		{
			for( var key in newData )
			{
				data[key] = newData[key];
			}
			NetworkManager.retrieveCustomDataDependencies(appManager, customDataDependencies, data, completion, index+1);
		})
	},

	getFacebookInfo: function(appManager, facebook_user_id, success, failure, networkFailure )
	{
		var methodName = "GetFacebookFeed";
		var parameters = [facebook_user_id, 2];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	getTwitterInfo: function(appManager, twitter_screen_name, success, failure, networkFailure )
	{
		var methodName = "GetTwitterFeed";
		var parameters = [twitter_screen_name, 2];
		this.rpcCall( appManager, methodName, parameters, success, failure, networkFailure);
	},

	alertHistory: function()
	{
		alert(JSON.stringify(history));
	},

	rpcCall: function( appManager, methodName, parameters, success, failure, networkFailure )
	{
		if( appManager.isLoggedIn() )
		{
			var networkManager = this;
      appManager.getCurrentUser(function(user)
      {
        var username = user != null ? user[ModelConstants.UserName] : null;
  			var password = user != null ? user[ModelConstants.Password] : null;
        networkManager.rpcCallUserPass( appManager, username, password, methodName, parameters, success, failure, networkFailure );
      })
		}
    else
    {
      this.rpcCallUserPass( appManager, null, null, methodName, parameters, success, failure, networkFailure );
    }
	},

	rpcCallHash: function( appManager, methodName, parameters, success, failure, networkFailure )
	{
		if( appManager.isLoggedIn() )
		{
			var networkManager = this;
      appManager.getCurrentUser(function(user)
      {
        var hash = user != null ? user[ModelConstants.Hash] : null;
        networkManager.rpcCallUserPass( appManager, hash, null, methodName, parameters, success, failure, networkFailure );
      })
		}
    else
    {
      this.rpcCallUserPass( appManager, null, null, methodName, parameters, success, failure, networkFailure );
    }
	},

	// if password is null and username is not null, then username is used as hash
	rpcCallUserPass: function( appManager, username, password, methodName, parameters, success, failure, networkFailure )
	{
		var networkManager = this;
		// var hash = crypto.createHmac('md5', "PALS_CLIENT_SECRET_1234").update(methodName).digest('hex');
    var hash = CryptoJS.HmacMD5(methodName, "PALS_CLIENT_SECRET_1234");
    hash = hash.toString(CryptoJS.enc.Hex);

		// console.log("methodName: " + methodName)
		// console.log("parameters: " + JSON.stringify(parameters))

		var serverURL = appManager.getServerURL() + "?hash=" + hash;

		var rpcInfo = {jsonrpc:'2.0',method:methodName, params:parameters, deviceinfo:appManager.getDeviceInfo(), id:randomString(8)};
		var appInfo = appManager.getAppInfo();
		if( appInfo.appid != "00000" )
		{
			rpcInfo.appInfo = appInfo;
		}
		// use offline mode
		if( shouldUseHistory )
		{
			setTimeout(function()
			{
				var key = username + password + methodName + JSON.stringify(parameters);
				var response = typeof history[key] !== 'undefined' ? history[key] : {};
				var data = typeof response !== 'undefined' && typeof response.data !== 'undefined' ? response["data"] : {};
				if( response["success"] )
				{
	        var isHaltingError = false;
	        if( typeof data["error"] !== 'undefined' && typeof data["error"]["code"] !== 'undefined' )
	        {
	          isHaltingError = networkManager.handleErrorCodeAndReturnIsHalting(data["error"]["code"]);
	        }

	        if( !isHaltingError )
	        {
	          if( typeof success !== 'undefined' && success != null ) success(data["result"]);
	        }
	        else
	        {
	          var result = {};
	          result["result"] = data["result"];
	          for( var key in data["error"] )
	          {
	            var value = data["error"][key];
	            result[key] = value;
	          }
	          if( typeof failure !== 'undefined' && failure != null ) failure(result);
	        }
				}
				else
				{
					var err = data;
	        if( typeof networkFailure !== 'undefined' ) networkFailure(err);
				}
			}, 100 )
			return;
		}
		var didRespond = false;
		var headers = {'Content-Type': 'application/json'};
		var xhrFields = {};
		// basic auth
		if( typeof username !== 'undefined' && username != null && typeof password !== 'undefined' && password != null )
		{
			var auth = global.btoa(username + ':' + password);
			headers = {"Authorization": "Basic " + auth, 'Content-Type': 'application/json'};
			xhrFields = {withCredentials:true};
		} // reup auth
		else if( typeof username !== 'undefined' && username != null )
		{
			headers = {"Authorization": "Hash " + username, 'Content-Type': 'application/json'};
			xhrFields = {withCredentials:true};
		}

		var responseTextCached = "DID NOT GET RESPONSE";
		if( ENABLE_LOGGING ) console.log("URL: " + serverURL + " param: " + JSON.stringify(rpcInfo) + " headers: " + JSON.stringify(headers))
    fetch(serverURL, {
      method: 'post',
      headers: headers,
		//mode: 'no-cors',
      body: JSON.stringify( rpcInfo )
    })
    .then((response) => response.text())
    .then((responseText) =>
    {
			responseTextCached = responseText;
			if( ENABLE_LOGGING ) console.log("Response: " + responseText.substr(0,80000))
      var data = JSON.parse(responseText);
      if( shouldRecordHistory )
			{
				var key = username + password + methodName + JSON.stringify(parameters);
				history[key] = {};
				history[key]["success"] = true;
				history[key]["data"] = data;
			}
      var isHaltingError = false;
      if( typeof data["error"] !== 'undefined' && typeof data["error"]["code"] !== 'undefined' )
      {
        isHaltingError = networkManager.handleErrorCodeAndReturnIsHalting(data["error"]["code"]);
      }
      if( !isHaltingError )
      {
				didRespond = true;
        if( typeof success !== 'undefined' && success != null ) success(data["result"], data["error"]);
      }
      else
      {
				didRespond = true;
        var result = {};
        result["result"] = data["result"];
        for( var key in data["error"] )
        {
          var value = data["error"][key];
          result[key] = value;
        }
        if( typeof failure !== 'undefined' && failure != null ) failure(result);
      }
    })
    .catch((err) =>
		{
			AnalyticsManager.logException(err + " :: " + methodName + " :: " + JSON.stringify(parameters) + " :: " + responseTextCached)
			if( ENABLE_LOGGING ) console.log("ERR: " + err,methodName,parameters, responseTextCached)
			if( didRespond ) return;
			if( shouldRecordHistory )
			{
				var key = username + password + methodName + JSON.stringify(parameters);
				history[key] = {};
				history[key]["success"] = false;
				history[key]["data"] = err;
			}
      if( typeof networkFailure !== 'undefined' ) networkFailure(err);
    });
	},

	handleErrorCodeAndReturnIsHalting: function(errorCode)
	{
		return parseInt(errorCode) < 0;
	},
};

// Register callback with AppDispatcher

module.exports = NetworkManager;



// WEBPACK FOOTER //
// ./src/NetworkManager.js